// src/utils/mask.js
export function maskIdCard(idCard) {
  if (!idCard || idCard.length < 10) return idCard;
  // 显示前6位和后4位，中间部分使用星号填充
  const prefix = idCard.slice(0, 6)
  const suffix = idCard.slice(-4)
  const stars = '*'.repeat(idCard.length - 10)
  return `${prefix}${stars}${suffix}`
}
